export default "__VITE_ASSET__ClPvIHzd__"